'use client';

import { useState, useEffect } from 'react';
import Terminal from './Terminal';
import BootSequence from './BootSequence';

function MobileLanding() {
  return (
    <div className="h-full overflow-y-auto bg-surface px-6 py-8">
      <div className="max-w-md mx-auto">
        <h1 className="text-amber font-bold text-[18px] tracking-wider mb-1">MOMENT</h1>
        <p className="text-secondary text-[12px] mb-6">Engineering</p>

        <div className="text-secondary text-[12px] leading-[1.8] space-y-4">
          <p>
            Moment builds software for investment management. We work with
            some of the world&apos;s largest wealth firms.
          </p>
          <p>
            This is a terminal for the engineering team&apos;s experiments,
            challenges, and other collateral.
          </p>
        </div>

        <div className="mt-8 p-4 bg-panel border border-stroke rounded-lg">
          <p className="text-primary text-[12px] font-bold mb-1">Best on desktop</p>
          <p className="text-dim text-[11px] leading-relaxed">
            The full terminal experience needs a desktop-sized screen.
          </p>
        </div>

        <div className="mt-6 text-dim text-[10px]">
          <a href="/disclosures" className="text-secondary hover:text-cyan underline underline-offset-2">Contest disclosures</a>
        </div>
      </div>
    </div>
  );
}

const BOOT_DONE_KEY = 'moment-boot-done';

export default function CommandCenter() {
  const [booting, setBooting] = useState(true);
  const [isMobile, setIsMobile] = useState<boolean | null>(null);

  useEffect(() => {
    if (sessionStorage.getItem(BOOT_DONE_KEY)) {
      setBooting(false);
    }
  }, []);

  const finishBoot = () => {
    sessionStorage.setItem(BOOT_DONE_KEY, '1');
    setBooting(false);
  };

  const triggerReboot = () => {
    sessionStorage.removeItem(BOOT_DONE_KEY);
    setBooting(true);
  };

  useEffect(() => {
    const handler = () => finishBoot();
    window.addEventListener('moment-logo-click', handler);
    return () => window.removeEventListener('moment-logo-click', handler);
  }, []);

  useEffect(() => {
    const isTouchDevice = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
    const tooNarrow = () => window.innerWidth < 480;
    setIsMobile(isTouchDevice || tooNarrow());
    if (!isTouchDevice) {
      const check = () => setIsMobile(tooNarrow());
      window.addEventListener('resize', check);
      return () => window.removeEventListener('resize', check);
    }
  }, []);

  if (booting) {
    return <BootSequence onComplete={finishBoot} />;
  }

  if (isMobile) {
    return <MobileLanding />;
  }

  return (
    <div className="h-full flex items-stretch terminal-reveal">
      <div className="w-full flex flex-col border-r border-stroke bg-panel overflow-hidden">
        <Terminal onRestart={triggerReboot} />
      </div>
    </div>
  );
}
